import * as Yup from 'yup';
import { User } from '@models';

export function useValidationSchema() {
  return Yup.object<User>().shape({
    username: Yup.string().nullable().required(),
  });
}
